module.exports = __webpack_public_path__ + "static/media/inputArrowLight.7bd5ece2.svg";